// App entry: register routes and start the hash router. The OMR engine runs in a
// Web Worker, loaded lazily on first scan, so the shell stays small and offline.
// Brand fonts, self-hosted (latin subset) so they work fully offline.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/zilla-slab/latin-700.css';
import './ui/styles.css';
import { route, startRouter } from './ui/router.js';
import { classesView } from './ui/views/classes.js';
import { classDetailView } from './ui/views/classDetail.js';
import { studentsView } from './ui/views/students.js';
import { studentDetailView } from './ui/views/studentDetail.js';
import { quizzesView, createQuizView } from './ui/views/quizzes.js';
import { testifyImportView } from './ui/views/testifyImport.js';
import { quizHubView } from './ui/views/quizHub.js';
import { answerKeyView } from './ui/views/answerKey.js';
import { scanPapersView } from './ui/views/scanPapers.js';
import { reviewView } from './ui/views/review.js';
import { resultDetailView } from './ui/views/resultDetail.js';
import { assignmentAnalysisView, quizAnalysisView } from './ui/views/analysis.js';
import { competenciesView } from './ui/views/competencies.js';
import { assignmentGapsView, quizGapsView } from './ui/views/gaps.js';
import { assignmentReportsView, quizReportsView } from './ui/views/reports.js';
import { settingsView } from './ui/views/settings.js';
import { aboutView } from './ui/views/about.js';
import { initPwa } from './pwa.js';

route('/', quizzesView); // Quiz is the home tab
route('/quizzes', quizzesView);
route('/classes', classesView);
route('/students', studentsView);
route('/student/:id', studentDetailView);
route('/class/:id', classDetailView);
route('/quizzes/new', createQuizView);
route('/testify/import', testifyImportView);
route('/quiz/:id', quizHubView);
route('/quiz/:id/key', answerKeyView);
route('/quiz/:id/competencies', competenciesView);
route('/assignment/:id/scan', scanPapersView);
route('/assignment/:id/review', reviewView);
route('/assignment/:id/analysis', assignmentAnalysisView);
route('/assignment/:id/gaps', assignmentGapsView);
route('/quiz/:id/analysis', quizAnalysisView);
route('/quiz/:id/gaps', quizGapsView);
route('/assignment/:id/reports', assignmentReportsView);
route('/quiz/:id/reports', quizReportsView);
route('/settings', settingsView);
route('/result/:id', resultDetailView);
route('/about', aboutView);

startRouter(document.getElementById('app')!);
initPwa();
